import axios, { AxiosResponse, CancelToken } from 'axios';

const getPaymentModes = async (cancelToken: CancelToken): Promise<AxiosResponse<PaymentType[]>> => {
  const API_URL = `/axfood/rest/checkout/paymentmodes`;
  return axios.get(API_URL, { cancelToken });
};

export default getPaymentModes;
